import { createOffer } from "@/service/global.api.js";
import Popup from "@/gts-popup.js";

/**
 * Handle create offer request and manage state
 * @param {Object} params - Parameters object
 * @param {Object} params.basketUuid - Basket UUID
 * @param {Number} params.entityType - Entity type (e.g., 3 for HOTEL)
 * @param {Number} params.pageSource - Page source (e.g., 1 for BASKET)
 * @param {String} [params.entityId] - Optional entity ID
 * @param {Function} params.onSuccess - Success callback
 * @param {Function} params.onError - Error callback
 * @param {Object} params.$store - Vuex store instance
 * @param {Object} params.$i18n - i18n instance
 * @returns {Promise}
 */
export function handleCreateOffer({ basketUuid, entityType, pageSource, entityId, onSuccess, onError, $store, $i18n }) {
   $store.commit("app/setIsProgressGifActive", true);

   const requestModel = {
      entityType,
      pageSource,
      referenceObjectUuid: basketUuid,
      ...(entityId && { entityId }),
   };

   return createOffer(requestModel)
      .then((response) => {
         console.log("Create offer response:", response);
         $store.commit("app/setIsProgressGifActive", false);

         if (response?.result?.success === false) {
            const errorMessage = response.errorMessage || $i18n.t("common_error");
            Popup.warning($i18n.t("popup_warningTitle"), errorMessage);

            if (onError) {
               onError(response);
            }
         } else if (response?.result?.success === true && response?.offerUrl) {
            window.open(response.offerUrl, "_blank");

            if (onSuccess) {
               onSuccess(response);
            }
         }

         return response;
      })
      .catch((error) => {
         console.error("Create offer error:", error);
         $store.commit("app/setIsProgressGifActive", false);

         if (onError) {
            onError(error);
         }

         throw error;
      });
}
